import { render } from "./BasicLineChart.vue?vue&type=template&id=70e7a074&ts=true"
import script from "./BasicLineChart.vue?vue&type=script&lang=ts"
export * from "./BasicLineChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__